import { render } from "./ContratacaoVigenteDetalheView.vue?vue&type=template&id=65c68682&scoped=true"
import script from "./ContratacaoVigenteDetalheView.vue?vue&type=script&lang=js"
export * from "./ContratacaoVigenteDetalheView.vue?vue&type=script&lang=js"

import "./ContratacaoVigenteDetalheView.vue?vue&type=style&index=0&id=65c68682&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c68682"]])

export default __exports__